import DragHandleIcon from "@material-ui/icons/DragHandle";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Chip from "@material-ui/core/Chip";
import ImageIcon from "@material-ui/icons/Image";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import { updateArticle, updateArticlesTranslations } from "../../../store/articles/ArticlesApi";
import withIntl from "../../../utils/withIntl";
import EditSwitch from "../../EditArticle/EditSwitch";
import { useDialog } from "../../Dialogs/DialogProvider";
import DialogImage from "../../Dialogs/DialogImage";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import ArticleDetailsDialog from "./ArticleDetailsDialog";
import PriceFieldArticle from "./PriceFieldArticle";
import cloudStore from "../../../store/CloudStore";
import { getTranslationValue } from "../../../store/articles/ArticlesHelpers";
import ActionButtonArticles from "../ActionButtons/ActionButtonArticles";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import TextFieldsIcon from "@material-ui/icons/TextFields";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    margin: 5,
    paddingTop: 5,
  },
  sizeSmall: { height: 14 },
  openDialogButton: {
    textAlign: "end",
  },
  section: {
    textAlign: "center",
    // border: "2px solid black",
  },
}));

function ArticleDraggable(props) {
  const classes = useStyles();
  const [article, setArticle] = React.useState(articlesStore.articles[props.articleId]);

  const [openDialog] = useDialog();

  const updateTranslations = (value) => {
    return updateArticlesTranslations(
      articlesStore.merchantId,
      [article],
      [{ translation: { [props.currentLanguage]: value } }]
    ).then(Promise.resolve());
  };

  function onChangeArticles() {
    setArticle(articlesStore.articles[props.articleId]);
  }

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    return () => {
      articlesStore.removeListener(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    };
  }, []);

  const handleOpenArticleDetailsDialog = () => {
    if (articlesStore.articles != null) {
      articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    }

    openDialog({
      children: (
        <ArticleDetailsDialog
          fullWidth={true}
          articleId={props.articleId}
          onClose={() => {
            articlesStore.removeListener(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
          }}
          setArticle={(article) => {
            setArticle(article);
          }}
          currentLanguage={props.currentLanguage}
        />
      ),
      fullWidth: true,
      maxWidth: "lg",
    });
  };

  return (
    <div ref={props.provided.innerRef} {...props.provided.draggableProps}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: 32,
          paddingRight: 16,
          paddingBottom: 8,
        }}
      >
        {!props.hideDragHandles && (
          <AuthorizationWrapper
            permission={"article.drag"}
            child={
              <ListItemIcon {...props.provided.dragHandleProps} style={{ cursor: "move" }}>
                <DragHandleIcon />
              </ListItemIcon>
            }
          />
        )}
        <Grid className={classes.root} container spacing={1} alignItems={"center"}>
          <Grid className={classes.section} item xs={12} sm={7} md={4}>
            <EditTextField
              key={article.name}
              authorizationField={
                "article.name" +
                (props.currentLanguage === cloudStore.merchant.default_language ? "" : ".other_language")
              }
              label={props.intl.formatMessage({ id: "article_name" })}
              value={getTranslationValue("name", "translation_id", props.currentLanguage, article, "")}
              placeholder={article.name}
              onBlur={(value, setBeginValue) => {
                if (props.currentLanguage === cloudStore.merchant.default_language) {
                  updateArticle(articlesStore.merchantId, article, { name: value }).then(() => setBeginValue(value));
                } else {
                  updateTranslations(value).then(() => setBeginValue(value));
                }
              }}
              variant={"standard"}
            />
          </Grid>
          <Grid className={classes.section} item xs={12} sm={5} md={2}>
            <PriceFieldArticle article={article} key={article.key} />
          </Grid>

          <Grid className={classes.section} item xs={3} sm={2} md={1} classes={{ item: classes.section }}>
            <AuthorizationWrapper
              permission={"article.id"}
              child={
                <Chip
                  classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                  variant="outlined"
                  label={"ID: " + article.id}
                  size="small"
                  color="primary"
                />
              }
            />
          </Grid>
          <Grid className={classes.section} item xs={3} sm={2} md={1} classes={{ item: classes.section }}>
            <AuthorizationWrapper
              permission={"article.plu"}
              child={
                <Chip
                  classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                  variant="outlined"
                  label={"PLU: " + article.plu}
                  size="small"
                  color="primary"
                />
              }
            />
            <AuthorizationWrapper
              permission={"article.plu_hubrise"}
              child={
                <EditTextField
                  key={article.plu}
                  label={props.intl.formatMessage({ id: "PLU" })}
                  value={article.plu === null ? "" : article.plu}
                  placeholder={article.plu}
                  onBlur={(value, setBeginValue) => {
                    let newValue = value === "" ? null : value;
                    if (newValue != null) {
                      updateArticle(articlesStore.merchantId, article, { plu: value }).then(() => setBeginValue(value));
                    }
                  }}
                  variant={"standard"}
                />
              }
            />
          </Grid>
          <Grid item xs={1} sm={2} md={1} classes={{ item: classes.section }}>
            {article.type !== "ARTICLE" && (
              <Tooltip title={article.type}>
                <IconButton
                  classes={{ root: classes.rootChip }}
                  size="small"
                  style={{
                    marginLeft: "10px",
                  }}
                >
                  {article.type === "SERVICE" ? <RoomServiceIcon /> : <TextFieldsIcon />}
                </IconButton>
              </Tooltip>
            )}
          </Grid>
          <Grid item xs={1} sm={2} md={1} classes={{ item: classes.section }}>
            {article.image ? (
              <Tooltip title={props.intl.formatMessage({ id: "uploaded" })}>
                <IconButton
                  classes={{ root: classes.rootChip }}
                  onClick={(e) => {
                    e.stopPropagation();
                    openDialog({
                      children: (
                        <DialogImage
                          imageUrl={"https://mynober-api-public.s3.eu-central-1.amazonaws.com/" + article.image}
                        />
                      ),
                    });
                  }}
                  size="small"
                  style={{
                    marginLeft: "10px",
                  }}
                >
                  <ImageIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </Grid>
          <Grid classes={{ item: classes.section }} item xs={2} sm={2} md={1}>
            <EditSwitch
              key={article.key}
              authorizationField={"article.manual_active"}
              value={!!article.manual_active && !!article.active}
              disabled={!article.active && cloudStore.merchant?.merchantable_type != null}
              onChange={(newValue, setBeginValue) => {
                updateArticle(articlesStore.merchantId, article, { manual_active: newValue, active: true }).then(() =>
                  setBeginValue(newValue)
                );
              }}
            />
          </Grid>
          <Grid classes={{ item: classes.openDialogButton }} item xs={2} sm={2} md={1}>
            <ActionButtonArticles article={article} handleOpenArticleDetailsDialog={handleOpenArticleDetailsDialog} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default withIntl(ArticleDraggable);
